import {
    AppSku,
    ContentCollectionContract,
    EntityType,
    SnapshotImageContract,
} from '@polaris-customerweb/sharedcomponents.core';
import {
    GeoBounds,
    GeoCoordinate,
} from '@polaris-customerweb/sharedcomponents.shared';
import { UserContentItem } from '@polaris-customerweb/sharedcomponents.user-content';
import { cloneDeep } from 'lodash-es';
import { Observable } from 'rxjs';
import { ContentCollection } from './content-collection';
import { Favorite } from './favorite';

// TODO: do not inherit from favorite
export class Collection extends Favorite implements UserContentItem {
    readonly type: EntityType = 'Collection';

    constructor(
        rawCollection: ContentCollectionContract = {},
        contentObservable$?: Observable<ContentCollection>
    ) {
        super(rawCollection, contentObservable$);
        this.rawCollectionBase = cloneDeep(rawCollection);
    }

    get description(): string {
        return (
            (this.rawCollectionBase as ContentCollectionContract).description ||
            ''
        );
    }
    set description(value: string) {
        (this.rawCollectionBase as ContentCollectionContract).description =
            value;
    }

    get geoCoordinate(): GeoCoordinate {
        return (
            this.contentCollection?.bounds?.centerGeoCoordinate ||
            new GeoCoordinate()
        );
    }

    get name(): string {
        return (this.rawCollectionBase as ContentCollectionContract).name || '';
    }
    set name(value: string) {
        (this.rawCollectionBase as ContentCollectionContract).name = value;
    }

    get snapshots(): readonly SnapshotImageContract[] {
        return (
            (this.rawCollectionBase as ContentCollectionContract).snapshots ||
            []
        );
    }

    static forAppSku(appSku: AppSku) {
        return new Collection({
            appSku,
            linkedItems: [],
        } as ContentCollectionContract);
    }

    clone(): Collection {
        const collection = new Collection(
            this.toContract(),
            this.contentObservable$
        );
        if (this.content) {
            collection.setContentCollection(this.contentCollection.clone());
        }

        return collection;
    }

    getUserContentItem(
        id: string,
        type: EntityType
    ): UserContentItem | undefined {
        return this.contentCollection.getUserContentItem(id, type);
    }

    override setContentCollection(
        contentCollection: ContentCollection,
        bounds?: GeoBounds
    ): void {
        super.setContentCollection(contentCollection, bounds);
    }

    override toContract(): ContentCollectionContract {
        return cloneDeep(this.rawCollectionBase as ContentCollectionContract);
    }

    override toGeoJson(): ContentCollectionContract {
        return this.toContract();
    }

    override toJSON(): ContentCollectionContract {
        return this.toGeoJson();
    }
}
